import React from 'react';

interface ThreeDTabProps {
  selectedFloor?: string;
  onFloorChange?: (floor: string) => void;
  onRefresh?: () => void;
  onFullscreen?: () => void;
  onSettings?: () => void;
}

const ThreeDTab: React.FC<ThreeDTabProps> = ({
  selectedFloor: _selectedFloor,
  onFloorChange: _onFloorChange,
  onRefresh: _onRefresh,
  onFullscreen: _onFullscreen,
  onSettings: _onSettings
}) => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h3>3D视图开发中...</h3>
      <p>将支持空间的3D可视化展示</p>
    </div>
  );
};

export default ThreeDTab;
